import React from "react";
import { Button, Tooltip } from "@mui/material";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import { useTranslation } from "react-i18next";
import { useDashboardShareReadiness } from "../../context/DashboardShareReadinessContext";

export default function DashboardShareButton({ visible, onOpen }) {
  const { t } = useTranslation("settings");
  const isShareReady = useDashboardShareReadiness();

  if (!visible) return null;

  const waitLabel = t("dashboardPresentation.waitForReport", {
    defaultValue: "Aguarde o relatório completo carregar na tela para compartilhar",
  });

  return (
    <Tooltip title={!isShareReady ? waitLabel : ""}>
      <span>
        <Button
          variant="outlined"
          size="small"
          startIcon={<ShareOutlinedIcon />}
          onClick={onOpen}
          disabled={!isShareReady}
          sx={{ whiteSpace: "nowrap", height: 36, textTransform: "none", fontWeight: 600, borderRadius: 2 }}
        >
          {t("dashboardPresentation.shareButton", { defaultValue: "Compartilhar" })}
        </Button>
      </span>
    </Tooltip>
  );
}
